<template>
  <canvas id="gridCanvas" />
</template>

<script>
import { easeLinear } from 'd3-ease';
import { timer } from 'd3-timer';


export default {
  props: {
    config: Object,
    numRows: Number,
    numCols: Number,
    dims: Object
  },
  watch: {
    config() {
      this.updateCanvas();
    },
    dims() {
      this.resize();
      this.updateCanvas();
    }
  },
  methods: {
    resize() {
      const el = document.querySelector('#gridCanvas');
      el.height = this.dims.height;
      el.width = this.dims.width;
    },
    updateCanvas() {
      if (this.config.action === "draw") {
        this.animateGrid('draw', this.config.duration);
      } else if (this.config.action === 'clear') {
        this.animateGrid('clear', this.config.duration);
      }
    },
    animateGrid(action, duration) {
      const ease = easeLinear;
      const width = this.dims.width;
      const height = this.dims.height;

      const myTimer = timer(elapsed => {

        const t = Math.min(1, ease(elapsed / duration));

        let colsToDraw = 0;
        let rowsToDraw = 0;
        let opacity = 0;

        if (action === 'draw') {
          colsToDraw = Math.ceil(this.numCols*t);
          rowsToDraw = Math.ceil(this.numRows*t);
          opacity = 1;
        }
        else {
          colsToDraw = this.numCols;
          rowsToDraw = this.numRows;
          opacity = (1-t);
        }
        this.drawGrid(width, height, rowsToDraw, colsToDraw, opacity);

        // if this animation is over
        if (t === 1) {
          // stop this timer since we are done animating.
          myTimer.stop()
        }
      });
    },
    drawGrid(width, height, rowsToDraw, colsToDraw, opacity) {
      // get elements
      const canvas = document.querySelector('#gridCanvas');
      const ctx = canvas.getContext('2d');

      // setup to darw
      ctx.save();
      ctx.clearRect(0, 0, width, height);
      ctx.beginPath();


      // rows
      const colHeight = height / this.numRows;
      for (let i=1; i<rowsToDraw; i++) {
        ctx.moveTo(0, i*colHeight);
        ctx.lineTo(width, i*colHeight);
      }

      // columns
      const rowWidth = width / this.numCols;
      for (let i=1; i<colsToDraw; i++) {
        ctx.moveTo(i*rowWidth, 0);
        ctx.lineTo(i*rowWidth, height);
      }

      // color and opacity
      ctx.globalAlpha = opacity;
      ctx.strokeStyle = 'rgba(230, 0, 0, .5)';
      ctx.lineWidth = 2;
      ctx.stroke();

      // draw
      ctx.restore();
    }
  }
}
</script>
